// State Object for Shop_groupsDistribution. Dont directly mutate it anywhere except the shop_groups/mutations.js file
export const shop_groupsDistributionState = {
  shop_groupsData: null,
  shop_groupList: null,
  shop_groupDetails: null
};
